<template>
  <div>
    <v-stepper-step step="5">
      <h3>REVIEW</h3>
      <div class="text-caption">
        Review the details you entered before submitting the declaration.
      </div>
    </v-stepper-step>
    <v-stepper-content step="5">
      <v-row>
        <v-col cols="12" md="6">
          <div>Sender</div>
          <div class="text-sm-body-2 text-body-2">
            <v-container>
              <v-row no-gutters>
                <v-col cols="4" md="3">
                  <span> Name: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.sender.name }}
                    {{ currentDeclaration.sender.surname }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4" md="3">
                  <span> Address: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>{{ currentDeclaration.sender.addressLine1 }}</span>
                  <span v-if="currentDeclaration.sender.addressLine2"
                    ><br />{{ currentDeclaration.sender.addressLine2 }}</span
                  >
                  <span><br />{{ currentDeclaration.sender.postcode }}</span>
                  <span><br />{{ currentDeclaration.sender.locality }}</span>
                  <span
                    ><br />{{
                      getCountryNameById(currentDeclaration.sender.countryId)
                    }}</span
                  >
                </v-col>
              </v-row>
              <v-row no-gutters v-if="currentDeclaration.sender.email">
                <v-col cols="4" md="3">
                  <span> Email: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.sender.email }}
                  </span>
                </v-col>
              </v-row>

              <v-row no-gutters v-if="currentDeclaration.sender.phone">
                <v-col cols="4" md="3">
                  <span> Phone: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.sender.phone }}
                  </span>
                </v-col>
              </v-row>

              <v-row no-gutters v-if="currentDeclaration.sender.vatNumber">
                <v-col cols="4" md="3">
                  <span> Vat No: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.sender.vatNumber }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="currentDeclaration.sender.voecNumber && getCountryRequiresVoec(currentDeclaration.recipient.countryId)">
                <v-col cols="4" md="3">
                  <span> VOEC No: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.sender.voecNumber }}
                  </span>
                </v-col>
              </v-row>

            </v-container>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div>Recipient</div>
          <div class="text-sm-body-2 text-body-2">
            <v-container>
              <v-row no-gutters>
                <v-col cols="4" md="3">
                  <span> Name: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.recipient.name }}
                    {{ currentDeclaration.recipient.surname }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4" md="3">
                  <span> Address: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>{{ currentDeclaration.recipient.addressLine1 }}</span>
                  <span v-if="currentDeclaration.recipient.addressLine2"
                    ><br />{{ currentDeclaration.recipient.addressLine2 }}</span
                  >
                  <span><br />{{ currentDeclaration.recipient.postcode }}</span>
                  <span><br />{{ currentDeclaration.recipient.locality }}</span>
                  <span
                    ><br />{{
                      getCountryNameById(currentDeclaration.recipient.countryId)
                    }}</span
                  >
                </v-col>
              </v-row>

              <v-row no-gutters v-if="currentDeclaration.recipient.email">
                <v-col cols="4" md="3">
                  <span> Email: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.recipient.email }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="currentDeclaration.recipient.phone">
                <v-col cols="4" md="3">
                  <span> Phone: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.recipient.phone }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="currentDeclaration.recipient.vatNumber">
                <v-col cols="4" md="3">
                  <span> Vat No: </span>
                </v-col>
                <v-col cols="8" md="8">
                  <span>
                    {{ currentDeclaration.recipient.vatNumber }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>

      <div>Category of Parcel Content</div>
      <div class="text-sm-body-2 text-body-2">
        <v-container style="margin-bottom: 10px">
          {{ currentDeclaration.contentCategory }}
          <span v-if="requiresContentCategoryDescription"
            >({{ currentDeclaration.contentCategoryDescription }})</span
          >
        </v-container>
      </div>

      <div v-if="currentDeclaration.recipient.isRequiresContentItems">
        Content Items
      </div>
      <div
        v-if="currentDeclaration.recipient.isRequiresContentItems"
        class="text-sm-body-2 text-body-2"
        style="padding-bottom: 20px"
      >
        <v-expansion-panels class="d-md-none" :hover="true">
          <v-expansion-panel
            v-for="item in currentDeclaration.contentItems"
            :key="item.key"
          >
            <v-expansion-panel-header>{{
              item.description
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                <span class="font-weight-bold">DESCRIPTION: </span
                ><span>{{ item.description }}</span>
              </p>
              <p>
                <span class="font-weight-bold">HS CODE: </span
                ><span>{{ item.hsCode }}</span>
              </p>
              <p>
                <span class="font-weight-bold">COUNTRY OF ORIGIN: </span
                ><span>{{ getCountryNameById(item.countryOfOriginId) }}</span>
              </p>
              <p>
                <span class="font-weight-bold">TOTAL QUANTITY: </span
                ><span>{{ item.quantity }}</span>
              </p>
              <p>
                <span class="font-weight-bold">VALUE (€): </span
                ><span>{{ item.value }}</span>
              </p>
              <p>
                <span class="font-weight-bold">WEIGHT PER ITEM (grams): </span
                ><span>{{ item.weight }}</span>
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-simple-table class="d-none d-md-block">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Decription</th>
                <th class="text-left">HS Code</th>
                <th class="text-left">Country of Origin</th>
                <th class="text-left">Total Quantity</th>
                <th class="text-left">Value (&euro;)</th>
                <th class="text-left">Weight per Item (g)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in currentDeclaration.contentItems"
                :key="item.key"
              >
                <td>{{ item.description }}</td>
                <td>{{ item.hsCode }}</td>
                <td>{{ getCountryNameById(item.countryOfOriginId) }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.value }}</td>
                <td>{{ item.weight }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <v-container fluid>
        <v-checkbox v-model="declarationAgreementAccepted">
          <template v-slot:label>
            <div>
              I certify that the particulars given in this Customs declaration
              are correct and that this item does not contain any dangerous
              article(s) prohibited by legislation or by postal or Customs
              regulation. For more information regarding dangerous goods, please
              follow
              <a
                target="_blank"
                href="https://www.maltapost.com/prohibited"
                v-on:click.stop="on"
                >this link</a
              >.
            </div>
          </template>
        </v-checkbox>
      </v-container>
      <vue-recaptcha
        class="mb-6"
        @verify="recaptchaVerified"
        :sitekey="recaptchaSiteKey"
        :loadRecaptchaScript="true"
      ></vue-recaptcha>
      <v-btn
        color="primary"
        :disabled="disableSubmit"
        @click="submitDeclaration()"
      >
        Submit Declaration
      </v-btn>
      <v-btn text @click="currentStep = 4" :disabled="disableBack">
        Back
      </v-btn>

      <v-progress-circular
        indeterminate
        color="primary"
        v-if="saving"
      ></v-progress-circular>
    </v-stepper-content>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("declarations");

export default {
  components: {
    VueRecaptcha,
  },
  data: () => ({
    isRecaptchaValid: false,
    recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
  }),
  computed: {
    ...mapGetters([
      "currentDeclaration",
      "countries",
      "requiresContentCategoryDescription",
      "sendingDocument",
    ]),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("declarations/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["declarations/currentStep"];
      },
    },
    saving: {
      set(saving) {
        this.$store.dispatch("declarations/setSaving", saving);
      },
      get() {
        return this.$store.getters["declarations/saving"];
      },
    },
    declarationAgreementAccepted: {
      set(declarationAgreementAccepted) {
        this.$store.dispatch(
          "declarations/Step05Review/setDeclarationAgreementAccepted",
          declarationAgreementAccepted
        );
      },
      get() {
        return this.$store.state.declarations.Step05Review
          .declarationAgreementAccepted;
      },
    },
    disableSubmit() {
      return (
        !this.declarationAgreementAccepted ||
        this.saving ||
        !this.isRecaptchaValid
      );
    },
    disableBack() {
      return this.saving;
    },
  },
  methods: {
    getCountryNameById: function (id) {
      if (id) {
        const country = this.countries.find(function (country) {
          return country.id === id;
        });
        return country ? country.name : "";
      }
      return "";
    },
    getCountryRequiresVoec: function (id) {
      if (id) {
        const country = this.countries.find(function (country) {
          return country.id === id;
        });
        return country ? country.requireVOEC: false;
      }
      return false;
    },

    submitDeclaration: function () {
      this.saving = true;
      this.$store.dispatch("declarations/submitDeclaration");
    },
    recaptchaVerified: function (recaptchaToken) {
      this.isRecaptchaValid = true;
      this.currentDeclaration.recaptchaToken = recaptchaToken;
    },
  },
};
</script>